import classNames from 'classnames'

import * as styles from './TableRowLoader.module.css'

function TableRowLoader() {
  return (
    <span
      className={classNames(styles.loader, styles.loaderActive)}
      style={{ '--end': 'forwards' }}
    />
  )
}

export default TableRowLoader
